import {BaseTO, SubProfile, TicketEventRes, TicketMetadata, TOInvoiceApprovingSubProfileItem} from "./BaseTO";
import {MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {TicketOverviewCL} from "../generated/TicketOverviewCL";
import {CachedPromise} from "../CachedPromise";
import {InvoiceApprovalCL} from "../generated/InvoiceApprovalCL";
import {Arrays, flashInfo, jsNextCycle, loadUrlContent, pairsToList, reviveLoadedElement, sleepPromise} from "../Utils";
import {TOIInvoiceApproving} from "./TOIInvoiceApproving";
import {UiComment} from "../UiComments";
import {UiFlashMessage} from "../UiFlashMessage";
import {Pager} from "../components/Pager";
import {DmsCL} from "../generated/DmsCL";
import {UiFlashMessageContainer} from "mu-widget/lib/UiFlashMessage";
import {MuRouter} from "mu-widget/lib/MuRouter";
import {UiBuSubjectsFilter} from "../dms/UiBuSubjects";
import {TicketEvent} from "../InvoiceTypes";

export class TOInvoiceApproving extends BaseTO {
	// public ticketListSize: number = 4;

	// public cl: TicketOverviewCL = new TicketOverviewCL();
	public clAppr: InvoiceApprovalCL = new InvoiceApprovalCL();
	// private filter: any = {};

	public orgDivisionPromise = new CachedPromise(() => this.cl.withMessage('Načítám organizační jednotky').getOrgDivisions(null, true));
	public orgProjectPromise = new CachedPromise(() => this.cl.withMessage('Načítám projekty').getOrgProjects(null, true));
	public orgProductPromise = new CachedPromise(() => this.clAppr.withMessage('Načítám produkty').getOrgProducts(null, true));
	public vendorPromise = new CachedPromise(() => this.cl.withMessage('Načítám subjekty').getAllInvVendors());
	public myBuSubjectPromise = new CachedPromise(() => this.cl.withMessage('Načítám firmy').getMyBuSubject());
	public accountingDocumentTypePairsPromise = new CachedPromise(() => this.cl.withMessage('Načítám typy dokladů').getAccountingDocumentTypePairs());
	public ticketTypePairsPromise = new CachedPromise(() => this.cl.withMessage('Načítám typy dokumentů').getTicketTypePairs("SNF"));
	public ticketTypePromise = new CachedPromise(async () => {
		const res = [];
		const pairs = await this.ticketTypePairsPromise.fetch();
		for(const k in pairs) res.push({ name: pairs[k], id: k });
		return res;
	});
	public accountingDocumentTypePromise = new CachedPromise(async() => pairsToList(await this.accountingDocumentTypePairsPromise.fetch()));

	private ticketFormIsChanged: boolean = false;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		pager: Pager
	}>;

	beforeIndex() {
		this.container.classList.add("ticket-overview");
		this.muAppendContent(
			this.htmlNavSubprofiles()
			+ this.htmlToolbar()
			+ `<div class="row">
				<div class="col-sm-${this.ticketListSize}">
					<table class="ticket-overview__stats" mu-id="stats">
						<tr mu-template="statsTotal" mu-widget="." class="ticket-overview__stats__total">
							<td mu-bind="totalCountLabel"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="buSubject" mu-widget="." class="ticket-overview__stats__bu-subject">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="documentType" mu-widget="." class="ticket-overview__stats__document-type">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="ticketType" mu-widget="." class="ticket-overview__stats__ticket-type">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<tr mu-template="accountingType" mu-widget="." class="ticket-overview__stats__accounting-type">
							<td mu-bind="name"></td>
							<td mu-bind="count" class="number"></td>
						</tr>
						<!-- <dt>Částka bez DPH:</dt><dt class="number" mu-bind="amountNT"></dt>
						<dt>Částka s DPH:</dt><dt class="number" mu-bind="amountWT"></dt>
						<dt>Počet:</dt><dt class="number" mu-bind="count"></dt> -->
					</table>
					<div mu-id="overviewItems" mu-bind="items:@foreach">
						<div mu-template="overviewItem" mu-widget="TOIInvoiceApproving"></div>
					</div>
					<div mu-widget="Pager" mu-id="pager"></div>
				</div>
				<div class="col-sm-${12 - this.ticketListSize}">
					<div mu-id="pTicket">
						<h2 mu-id="ticketLabel" class="ticket-overview__form-label">
							<span class="ticket-overview__form-label__evidence-uid" mu-bind="evidenceUid"></span>
							<span class="ticket-overview__form-label__bu-subject" mu-bind="buSubjectName"></span>
							<span class="ticket-overview__form-label__accounting-document-type" mu-bind="accountingDocumentType"></span>
						</h2>
						<ul class="bcm-nav-tabs">
							<li mu-id="btn_form" mu-click='showTicketPanel: "form"'><a>Detail</a></li>
							<li mu-id="btn_history" mu-click='showTicketPanel: "history"'><a>Historie</a></li>
						</ul>
	
						<div mu-id="form" mu-widget="."></div>
						<div mu-id="history" mu-widget="."></div>
						<div mu-widget="UiComment" mu-id="comments" mu-params='{"isRoot":true}'></div>
					</div>
					<div class="alert-success alert" mu-id="pNoTicket">Tomuto zobrazení neodpovídá ani jedna položka.</div>
				</div>
			</div>
		`);
		this.setupRouter();
	}

	public getFormOptions(): any
	{
		return this.currentSubProfile.formOptions;
	}

	public async updateSubprofileCounts() {
		const counts = await this.cl.getSubProfileCounts(this.profile.id);
		this.muGetChildWidgets<TOInvoiceApprovingSubProfileItem>('subProfiles').forEach(spw => {
			spw.setCount(counts[spw.subProfile.id]);
		});
	}

	async afterIndex() {
		super.afterIndex();
		this.setupSubProfiles(await this.subprofiles.fetch());
		// this.loadList();
		// @ts-ignore
		this.showTicketPanel(null, 'form');
		this.router.route();
	}

	public invoiceChanges(changes: TicketEvent[])
	{
		const res: TicketEventRes = {};
		changes = Arrays.unique(changes);
		for(const ev of changes) {
			const eva = (this.currentSubProfile.events||{})[ev];
			if (eva) {
				res.action = eva;
				switch (eva) {
					case "reloadNext":
						this.ticketFormIsChanged = false;
						this.loadList(true);
						break;
					case "reloadSame":
						this.loadList(false);
						break;
				}
			}
		}

		return res;
	}

	bFilter_click() {
		this.openInModal(
			"InvoiceApprovingFilter",
			"Filtr",
			{
				getFilter: () => this.filter,
				setFilter: (filter:any) => this.setFilter(filter),
				orgDivisionPromise: this.orgDivisionPromise,
				orgProjectPromise: this.orgProjectPromise,
				orgProductPromise: this.orgProductPromise,
				vendorPromise: this.vendorPromise,
				myBuSubjectPromise: this.myBuSubjectPromise,
				accountingDocumentTypePromise: this.accountingDocumentTypePromise,
				ticketTypePromise: this.ticketTypePromise,
			}
		);
	}

	protected allTicketPanels = ["form", "history"];

	showTicketPanel(ev: Event, panel: string) {
		for(const k of this.allTicketPanels) {
			this.muVisible(panel === k, k);
			this.ui["btn_" + k].classList.toggle("active",panel === k);
		}
	}

	protected async loadList(loadNext = true) {

		const data = await this.cl.withMessage("Načítám položky").getTickets(
			this.profile.id,
			this.currentSubProfile.id,
			{fulltext: this.ui.cFulltext.value, ...this.filter},
			this.muNamedWidget.pager.currentItemFrom ?? 0,
			this.muNamedWidget.pager.itemPerPage
		);
		this.muBindData(data);
		await this.showStats(data.stats);
		if (loadNext && !this.isFormChanged()) {
			if (data.items.length) {
				this.loadTicket(data.items[0]);
			} else {
				this.noTicket(true);
			}
		}
		this.markSelectedTicket();
		setTimeout(() => this.updateSubprofileCounts(), 1000);
	}

	public async reloadTicketAndList() {
		return Promise.all([
			this.loadList(false),
			this.loadTicket(this.currentTicket.id),
		]);
	}

	protected async showStats(stats: any[]) {

		// Statistika
		let fullCount = 0;
		let countByBuSubject: Record<number, number> = {};
		let statsByAdt: Record<number, Record<number, number>> = {};
		let statsByTT: Record<number, Record<number, number>> = {};
		const accountingDocumentTypeNames = await this.accountingDocumentTypePairsPromise.fetch();
		const ticketTypeNames = await this.ticketTypePairsPromise.fetch();
		for(const stat of stats) {
			fullCount += stat.count;
			countByBuSubject[stat.buSubjectId] = countByBuSubject[stat.buSubjectId] || 0;
			countByBuSubject[stat.buSubjectId] += stat.count;
			if (this.currentSubProfile.groupByAccountingDocumentType) {
				statsByAdt[stat.buSubjectId] = statsByAdt[stat.buSubjectId] || {};
				statsByAdt[stat.buSubjectId][stat.accountDocumentTypeId] = stat.count;
			}
			if (this.currentSubProfile.groupByTicketType) {
				statsByTT[stat.buSubjectId] = statsByTT[stat.buSubjectId] || {};
				statsByTT[stat.buSubjectId][stat.ticketTypeId] = stat.count;
			}
		}

		(this.muNamedWidget.pager as unknown as Pager).setItemCount(fullCount);

		const buSubjectNames: Record<number, string> = {};
		for(const buSubject of (await this.myBuSubjectPromise.fetch()))
			buSubjectNames[buSubject.id] = buSubject.name;
		this.ui.stats.innerHTML = "";
		this.muWidgetFromTemplate("statsTotal", "stats")
			.muBindData({totalCountLabel: this.currentSubProfile.totalCountLabel ,count: fullCount});
		for(const buSubjectId in countByBuSubject) {
			const isActive = this.filter.buSubjectId?.includes(buSubjectId) ?? false;
			const wb = this.muWidgetFromTemplate("buSubject", "stats", {
				container_click: () => {
					this.patchFilter({
						buSubjectId: isActive ? null : [buSubjectId],
					});
				}
			});
			wb.muBindData({
				// u klíče se převede na string
				name: buSubjectId != 'null' ? buSubjectNames[buSubjectId] : "nezadáno",
				count: countByBuSubject[buSubjectId],
			});
			wb.container.classList.toggle('active', isActive);

			if (this.currentSubProfile.groupByAccountingDocumentType) {
				for (const accountingDocumentTypeId in statsByAdt[buSubjectId]) {
					const isActive = (this.filter.accountingDocumentTypeId?.includes(accountingDocumentTypeId)
						&& this.filter.buSubjectId?.includes(buSubjectId)) ?? false;
					const w = this.muWidgetFromTemplate(
						"accountingType",
						"stats",
						{
							container_click: () => {
								this.patchFilter({
									accountingDocumentTypeId: isActive ? null : [ accountingDocumentTypeId ],
									buSubjectId: isActive ? null : [ buSubjectId ], // this.filter.buSubjectId = isActive ? null : [ buSubjectId ];
								}); // this.filter.accountingDocumentTypeId = isActive ? null : [ accountingDocumentTypeId ];
							}
						});
					w.muBindData({
						// u klíče se převede na string
						name: accountingDocumentTypeId != 'null' ? accountingDocumentTypeNames[accountingDocumentTypeId] : "nezadáno",
						count: statsByAdt[buSubjectId][accountingDocumentTypeId],
					});
					w.container.classList.toggle('active', isActive);
				}
			}
			if (this.currentSubProfile.groupByTicketType) {
				for (const ticketTypeId in statsByTT[buSubjectId]) {
					const isActive = (this.filter.ticketTypeId?.includes(ticketTypeId)
						&& this.filter.buSubjectId?.includes(buSubjectId)) ?? false;
					const w = this.muWidgetFromTemplate(
						"ticketType",
						"stats",
						{
							container_click: () => {
								this.patchFilter({
									ticketTypeId: isActive ? null : [ticketTypeId],
									buSubjectId: isActive ? null : [buSubjectId],
								});
							}
						});
					w.muBindData({
							// u klíče se převede na string
							name: ticketTypeId != 'null' ? ticketTypeNames[ticketTypeId] : "nezadáno",
							count: statsByTT[buSubjectId][ticketTypeId],
						}
					);
					w.container.classList.toggle('active', isActive);
				}
			}
		}
	}

	pager_changePage() {
		this.loadList();
	}

	async loadHistory(id: number) {
		this.ui.history.innerHTML = await this.cl.withMessage("Načítám historii", this.ui.form)
			.loadRawData("/ticket/history/" + id + "?part=form") ?? "Chyba načtení";
	}

	async loadForm(id: number, data: any = null) {
		// this.ui.form.classList.add('loading-data');
		const html = await this.cl.withMessage(data ? "Odesílám požadavek" : "Načítám požadavek", this.ui.form)
			.loadRawData("/ticket/detail/" + id + "?part=form", data) ?? "Chyba načtení";
		//todo:
		if (html.startsWith('{')) {
			const data = JSON.parse(html);
			this.ticketFormIsChanged = false;
			UiFlashMessage.instance.add("Uloženo");
			this.ui.form.innerHTML = "Uloženo";
			switch(this.currentSubProfile.afterSaveTicket) {
				case "sameTicket":
					await this.loadList(false);
					await this.loadTicket(data);
					break;
				case "nextTicket":
					await this.loadList(true);
					break;
			}
		} else {
			this.ui.form.innerHTML = html;
			jsNextCycle();
			reviveLoadedElement(this.ui.form);
			this.muActivateWidget(this.ui.form, null, undefined);

			const form = this.ui.form.querySelector("form") as HTMLFormElement;
			if (form) {
				form.addEventListener("submit", async (ev) => {
					ev.preventDefault();

					const fd = new FormData(form);
					// @ts-ignore
					fd.append(ev.submitter.name, ev.submitter.value);

					sleepPromise(200).then(() => this.loadHistory(id));
					await this.loadForm(id, fd);
				});
				form.addEventListener("change", (ev) => {
					this.ticketFormChanged();
					// console.log(ev);
				});
				// this.ui.form.classList.remove('loading-data');
				await sleepPromise(200);
				if (this.currentSubProfile.hideTicketButtons) this.muNamedWidget.form.muVisible(false, 'ticketButtons');
				if (this.currentSubProfile.hideTicketSaveButtons && this.muNamedWidget.form.ui.btSubmitPlace) this.muNamedWidget.form.muVisible(false, 'btSubmitPlace');
			}
		}
	}

	protected currentTicket: any = null;

	protected noTicket(noTicket: boolean) {
		this.muVisible(noTicket, ["!pTicket", "pNoTicket"]);
	}

	async loadTicket(srcOrId: TicketMetadata|number) {
		this.noTicket(false);
		const src: TicketMetadata = (typeof srcOrId !== "object")
			? await this.cl.getTicketMetadata(srcOrId)
			: srcOrId;

		this.router.pushUpdate('ticket', { ticketId: src.id?.toString() });

		// if (this.isFormChanged() && !confirm("Údaje ve formuláři byly změněny. Načtením jiné faktury o změny přijdete, chcete opravdu načíst tuto fakturu?"))
		// 	return;

		let subject = src.buSubjectName || "";
		switch (this.currentSubProfile.subjectInTitle) {
			case true: subject += " " + src.summary; break;
			case null: subject = subject || src.summary; break;
		}

		this.muBindData({
			evidenceUid: src.evidenceUid,
			buSubjectName: subject,
			accountingDocumentType:
				this.currentSubProfile.accountingDocumentTypePrefix
				+ ((await this.accountingDocumentTypePairsPromise.fetch())[src.accountDocumentTypeId ?? ""] ?? "")
				+ (this.currentSubProfile.ticketStateInTitle ? " " + (src.stateName?.toLowerCase() ?? "") : ""),

		})

		this.currentTicket = src;

		this.ticketFormIsChanged = false;
		this.markSelectedTicket();
		const pForm = this.loadForm(src.id);
		const pHistory = this.loadHistory(src.id);
		let pComments = null;

		const useComments = typeof this.currentSubProfile.useComments === "boolean"
			? this.currentSubProfile.useComments
			: src.useComments;
		if (useComments)
			pComments = (this.muNamedWidget.comments as unknown as UiComment).loadComments(src.id);
		this.muVisible(useComments, "comments");

		return Promise.all([
			pForm,
			pHistory,
			pComments,
		]);
	}

	private ticketFormChanged() {
		this.ticketFormIsChanged = true;
	}

	public async onInvoiceCreated(ticketId: number) {
		flashInfo("Faktura byla vytvořena");
		this.ticketFormIsChanged = false;
		// this.cl.callStateAction(ticketId, "invoiceCreated");
		this.loadList(this.currentSubProfile.afterSaveInvoice === "nextTicket");
	}

	onApprovingStateChange() {
		this.ticketFormIsChanged = false;
		this.loadList();
	}

	protected formChangedCallback: (()=>boolean)|null = null;
	public isFormChanged(): boolean
	{
		return this.formChangedCallback
			? this.formChangedCallback()
			: this.ticketFormIsChanged;

	}

	public setFormChangedCallback(callback: (()=>boolean)|null) {
		this.formChangedCallback = callback;
	}

	public prepareTicketAnchor(a: HTMLElement, id: number|string) {
		this.router.prepareAnchor(a as unknown as HTMLAnchorElement, "ticket", { ticketId: id.toString() });
	}

}

